document.addEventListener('DOMContentLoaded', () => {
  // Injectare stiluri pentru selectoarele de cantitate optimizate pentru bătrâni
  const qtyStyle = document.createElement('style');
  qtyStyle.innerHTML = `
    .dds-qty-selector-group {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-top: 8px;
      margin-bottom: 10px;
      width: 100%;
      box-sizing: border-box;
    }
    .dds-qty-option-row {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      border: 2px solid #e5e7eb;
      border-radius: 8px;
      cursor: pointer;
      background: #ffffff;
      transition: all 0.2s ease;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      box-sizing: border-box;
    }
    .dds-qty-option-row:hover {
      border-color: #cbd5e1;
    }
    .dds-qty-option-row.active {
      border-color: #0b6e5f;
      background: #f0fdfa;
    }
    .dds-qty-radio-circle {
      width: 18px;
      height: 18px;
      border: 2px solid #cbd5e1;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: all 0.2s ease;
      box-sizing: border-box;
    }
    .dds-qty-option-row.active .dds-qty-radio-circle {
      border-color: #0b6e5f;
    }
    .dds-qty-radio-circle.checked::after {
      content: "";
      width: 10px;
      height: 10px;
      background: #0b6e5f;
      border-radius: 50%;
      display: block;
    }
    .dds-qty-text-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      font-family: inherit;
    }
    .dds-qty-label {
      font-size: 13px;
      color: #374151;
      text-align: left;
    }
    .dds-qty-price {
      font-size: 13px;
      font-weight: 600;
      color: #111827;
    }
    @media (max-width: 767px) {
      .dds-qty-option-row {
        padding: 12px 14px;
      }
      .dds-qty-label {
        font-size: 14px;
      }
      .dds-qty-price {
        font-size: 14px;
      }
    }
   `;
  document.head.appendChild(qtyStyle);

  // Funcție globală pentru selectarea cantității din card
  window.ddsSelectQty = function(uniqueId, qty, variantId, totalPrice) {
    const group = document.getElementById(`group_${uniqueId}`);
    if (!group) return;
    
    const rows = group.querySelectorAll('.dds-qty-option-row');
    rows.forEach(row => {
      row.classList.remove('active');
      const circle = row.querySelector('.dds-qty-radio-circle');
      if (circle) circle.classList.remove('checked');
    });

    const selectedRow = Array.from(rows).find(row => {
      return row.getAttribute('onclick').includes(`'${uniqueId}', ${qty}`);
    });

    if (selectedRow) {
      selectedRow.classList.add('active');
      const circle = selectedRow.querySelector('.dds-qty-radio-circle');
      if (circle) circle.classList.add('checked');
    }

    const card = group.closest('.dds-chat-product-card');
    if (card) {
      const addBtn = card.querySelector('.dds-chat-add-btn');
      if (addBtn) {
        addBtn.setAttribute('data-qty', qty);
        addBtn.setAttribute('data-vid', variantId);
      }
    }
  };

  const toggleBtn = document.getElementById('ddsChatToggle');
  const closeBtn = document.getElementById('ddsChatClose');
  const fullscreenBtn = document.getElementById('ddsChatFullscreenToggle');

  const chatWidget = document.querySelector('.dds-chat-widget');
  const chatWindow = document.getElementById('ddsChatWindow');
  const chatInput = document.getElementById('ddsChatInput');
  const sendBtn = document.getElementById('ddsChatSend');
  const messagesContainer = document.getElementById('ddsChatMessages');
  const typingIndicator = document.getElementById('ddsTypingIndicator');

  // Gestionare mod Fullscreen pe Desktop cu blocare completa scroll pe background
  function setFullscreenState(isFull) {
    if (!chatWindow) return;
    chatWindow.classList.toggle('is-fullscreen', isFull);
    if (chatWidget) chatWidget.classList.toggle('is-fullscreen-widget', isFull);
    
    if (isFull) {
      if (fullscreenBtn) {
        fullscreenBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg>`;
        fullscreenBtn.setAttribute('title', 'Micșorează');
      }
      document.documentElement.classList.add('chatbot-fullscreen-open');
      document.body.classList.add('chatbot-fullscreen-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', preventScrollOutsideChat, { passive: false });
      document.addEventListener('touchmove', preventScrollOutsideChat, { passive: false });
    } else {
      if (fullscreenBtn) {
        fullscreenBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>`;
        fullscreenBtn.setAttribute('title', 'Afișează pe tot ecranul');
      }
      document.documentElement.classList.remove('chatbot-fullscreen-open');
      document.body.classList.remove('chatbot-fullscreen-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (window.innerWidth > 989) {
        document.removeEventListener('wheel', preventScrollOutsideChat);
        document.removeEventListener('touchmove', preventScrollOutsideChat);
      }
    }
  }

  if (fullscreenBtn) {
    fullscreenBtn.addEventListener('click', () => {
      const willBeFull = !chatWindow.classList.contains('is-fullscreen');
      setFullscreenState(willBeFull);
    });
  }

  // Config setup via window.DDS_CHATBOT_CONFIG injected in liquid
  const CF_WORKER_URL = window.DDS_CHATBOT_CONFIG?.workerUrl || 'https://chatbot-dds.miclaus-razvan.workers.dev/'; 
  const AVATAR_URL = window.DDS_CHATBOT_CONFIG?.avatarUrl || '';

  let messageHistory = [];
  let isGenerating = false;
  let interactionCount = 0;

  // ── Blocare scroll body cand chatbot-ul e deschis ──────────────────────────
  // Previne scroll bleed pe mobile (touchmove) si pe desktop (wheel)
  // Scroll-ul este permis DOAR in interiorul containerului de mesaje
  function preventScrollOutsideChat(e) {
    const allow = messagesContainer && messagesContainer.contains(e.target);
    if (!allow) e.preventDefault();
  }

  function lockBodyScroll() {
    if (window.innerWidth > 989) return; // Permite scroll liber pe Desktop
    document.addEventListener('touchmove', preventScrollOutsideChat, { passive: false });
    document.addEventListener('wheel',     preventScrollOutsideChat, { passive: false });
  }

  function unlockBodyScroll() {
    document.removeEventListener('touchmove', preventScrollOutsideChat);
    document.removeEventListener('wheel',     preventScrollOutsideChat);
  }
  // ───────────────────────────────────────────────────────────────────────────

  // Scroll orizontal inteligent (unu-câte-unu)
  window.ddsScrollFaq = function(direction) {
    const container = document.getElementById('ddsFaqButtons');
    if (!container) return;
    
    // Găsim toate butoanele din interior
    const buttons = Array.from(container.querySelectorAll('.dds-chat-quick-btn'));
    if (!buttons.length) return;

    let targetLeft = container.scrollLeft + (direction * 180);

    if (direction > 0) {
      // În dreapta: găsește primul buton a cărui margine este spre dreapta față de poziția actuală
      const nextBtn = buttons.find(b => b.offsetLeft > container.scrollLeft + 20);
      if (nextBtn) targetLeft = nextBtn.offsetLeft;
    } else {
      // În stânga: găsește ultimul buton a cărui margine este spre stânga față de poziția actuală
      const reversed = [...buttons].reverse();
      const prevBtn = reversed.find(b => b.offsetLeft < container.scrollLeft - 20);
      if (prevBtn) targetLeft = prevBtn.offsetLeft;
    }

    container.scrollTo({ left: targetLeft, behavior: 'smooth' });
  };

  const faqContainer = document.getElementById('ddsFaqButtons');
  if (faqContainer) {
    faqContainer.addEventListener('scroll', () => {
      const leftArrow = document.getElementById('ddsFaqNavLeft');
      const rightArrow = document.getElementById('ddsFaqNavRight');
      if (leftArrow && rightArrow) {
        // Ascunde săgeata stânga dacă suntem la început
        if (faqContainer.scrollLeft <= 5) {
          leftArrow.style.opacity = '0';
          leftArrow.style.pointerEvents = 'none';
        } else {
          leftArrow.style.opacity = '1';
          leftArrow.style.pointerEvents = 'auto';
        }
        
        // Ascunde săgeata dreapta dacă suntem la final
        if (faqContainer.scrollLeft + faqContainer.clientWidth >= faqContainer.scrollWidth - 5) {
          rightArrow.style.opacity = '0';
          rightArrow.style.pointerEvents = 'none';
        } else {
          rightArrow.style.opacity = '1';
          rightArrow.style.pointerEvents = 'auto';
        }
      }
    });
  }

  // Permanently remove FAQ section after first interaction
  function hideFaqPermanently() {
    const faq = document.getElementById('ddsChatQuickReplies');
    if (faq) faq.classList.add('dds-faq-gone');
  }

  // Toggle chat
  toggleBtn.addEventListener('click', () => {
    chatWindow.classList.add('active');
    toggleBtn.style.display = 'none';
    
    // Ascunde Contact FAB cat timp chatbot-ul e deschis
    const fabContainer = document.getElementById('ddsContactFabContainer');
    if (fabContainer) fabContainer.classList.add('chatbot-hidden');

    // Ascunde WhatsApp cat timp chatbot-ul e deschis
    const waBtn = document.querySelector('.dds-wa-float');
    if (waBtn) waBtn.classList.add('wa-chatbot-hidden');
    // Ascunde navbar mobile + blocheaza scroll din spate
    document.body.classList.add('chatbot-open');
    lockBodyScroll();
  });

  function closeChatbot() {
    chatWindow.classList.remove('active');
    toggleBtn.style.display = 'flex';
    
    // Reseteaza modul fullscreen garantat cand chatbot-ul e inchis
    setFullscreenState(false);

    // Readuce Contact FAB inapoi
    const fabContainer = document.getElementById('ddsContactFabContainer');
    if (fabContainer) fabContainer.classList.remove('chatbot-hidden');

    // Readuce WhatsApp inapoi
    const waBtn = document.querySelector('.dds-wa-float');
    if (waBtn) waBtn.classList.remove('wa-chatbot-hidden');
    // Reafișează navbar mobile + deblocheaza scroll
    document.body.classList.remove('chatbot-open');
    unlockBodyScroll();
  }

  closeBtn.addEventListener('click', closeChatbot);


  // Render a message in the UI
  function addMessage(text, role) {
    const wrapper = document.createElement('div');
    wrapper.className = `dds-message-wrapper ${role}-wrapper`;

    if (role === 'assistant') {
      const avatar = document.createElement('img');
      avatar.src = AVATAR_URL;
      avatar.className = 'dds-message-avatar';
      avatar.alt = 'Elena';
      wrapper.appendChild(avatar);
    }

    const msgDiv = document.createElement('div');
    msgDiv.className = `dds-message ${role}`;
    
    // Parse simplified markdown if assistant
    if (role === 'assistant') {
      let formatted = text
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener" class="dds-chat-link">$1</a>')
        .replace(/\n/g, '<br>')
        .replace(/0771\s*104\s*521/g, '<a href="tel:0771104521" style="font-weight: 700; color: #0b6e5f; text-decoration: underline;">0771 104 521</a>');
      
      // Handle Product Tags {{PRODUCT:handle|beneficiu}}
      msgDiv.innerHTML = formatted;
      wrapper.appendChild(msgDiv);
      messagesContainer.insertBefore(wrapper, document.getElementById('ddsTypingWrapper'));
      
      // Parsam markerii si inseram carduri in chat (ca elemente separate, DUPA mesajul text)
      const productRegex = /\{\{PRODUCT:([^\|}]+)(?:\|([^}]+))?\}\}/g;
      let match;
      const productsToFetch = [];
      while ((match = productRegex.exec(text)) !== null) {
        const handle = match[1].trim();
        const benefit = (match[2] || 'Sursa 100% naturala').trim();
        productsToFetch.push({ handle, benefit });
      }
      
      // Sterge markerii bruti din textul afisat
      msgDiv.innerHTML = msgDiv.innerHTML.replace(/\{\{PRODUCT:[^}]+\}\}/g, '');

      if (productsToFetch.length > 0) {
        Promise.all(productsToFetch.map(p => fetchProductCard(p.handle, p.benefit)))
          .then(() => {
            scrollToMessageStart(wrapper);
          });
      }

    } else {
      msgDiv.textContent = text;
      wrapper.appendChild(msgDiv);
      messagesContainer.insertBefore(wrapper, document.getElementById('ddsTypingWrapper'));
    }

    // Scroll: user → scrollToBottom; assistant → sare la inceputul noului mesaj
    if (role === 'assistant') {
      scrollToMessageStart(wrapper);
    } else {
      scrollToBottom();
    }

    return wrapper;
  }

  // Insereaza cardul produsului in fluxul de chat, inainte de typing indicator
  async function fetchProductCard(handle, benefit) {
    try {
      // Handle-urile sunt curate (fara caractere speciale) — folosim encodeURIComponent standard
      const encodedHandle = encodeURIComponent(handle);
      let res = await fetch(`/products/${encodedHandle}.js`);
      if (!res.ok) {
        // Fallback: incearca handle-ul direct
        res = await fetch(`/products/${handle}.js`);
      }
      // Fallback: AI uneori omite prefixul "life-" din handle
      if (!res.ok && !handle.startsWith('life-')) {
        res = await fetch(`/products/life-${handle}.js`);
      }
      if (!res.ok) {
        console.warn(`Product not found: ${handle}`);
        return;
      }
      const product = await res.json();
      
      const card = document.createElement('div');
      card.className = 'dds-chat-product-card';
      
      const formatMoney = (cents) => new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(cents / 100);

      // Preț de bază (var 1)
      const variant1 = product.variants && product.variants[0];
      const variant1Id = variant1 ? variant1.id : '';
      const basePrice = (variant1 ? variant1.price : 0) / 100;

      // Selectoare cantitate cu upsell inteligent: 1 buc, 4 buc (-5%), 8 buc (-15%)
      const p1 = basePrice;
      const p4 = basePrice * 4 * 0.95; // 5% discount
      const p8 = basePrice * 8 * 0.85; // 15% discount
      
      const formatRON = (val) => new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' }).format(val);
      const uniqueId = 'prod_' + Math.random().toString(36).substr(2, 9);
      const defaultQty = 1;

      const variantsHtml = `
        <div class="dds-qty-selector-group" id="group_${uniqueId}">
          <div class="dds-qty-title" style="font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 4px; text-align: left;">Alege pachetul:</div>
          <div class="dds-qty-option-row active" onclick="ddsSelectQty('${uniqueId}', 1, '${variant1Id}', ${p1})">
            <div class="dds-qty-radio-circle checked"></div>
            <div class="dds-qty-text-area">
              <span class="dds-qty-label">1 Bucată</span>
              <span class="dds-qty-price">${formatRON(p1)}</span>
            </div>
          </div>
          <div class="dds-qty-option-row" onclick="ddsSelectQty('${uniqueId}', 4, '${variant1Id}', ${p4})">
            <div class="dds-qty-radio-circle"></div>
            <div class="dds-qty-text-area">
              <span class="dds-qty-label" style="font-weight: 700; color: #0b6e5f;">4 Bucăți <span style="font-size: 0.85em; background: #e6f4f1; color: #0b6e5f; padding: 2px 6px; border-radius: 4px; margin-left: 4px; font-weight: 600;">-5% + Transport GRATUIT</span></span>
              <span class="dds-qty-price" style="font-weight: 700; color: #0b6e5f;">${formatRON(p4)}</span>
            </div>
          </div>
          <div class="dds-qty-option-row" onclick="ddsSelectQty('${uniqueId}', 8, '${variant1Id}', ${p8})">
            <div class="dds-qty-radio-circle"></div>
            <div class="dds-qty-text-area">
              <span class="dds-qty-label" style="font-weight: 700; color: #c9660a;">8 Bucăți <span style="font-size: 0.85em; background: #fff7ed; color: #c9660a; padding: 2px 6px; border-radius: 4px; margin-left: 4px; font-weight: 600;">-15% + Transport GRATUIT</span></span>
              <span class="dds-qty-price" style="font-weight: 700; color: #c9660a;">${formatRON(p8)}</span>
            </div>
          </div>
        </div>
      `;
      
      const img = product.featured_image ? product.featured_image : '';
      const defaultVid = variant1Id;

      card.innerHTML = `
        <div class="dds-chat-product-top">
          <img src="${img}" class="dds-chat-product-img" alt="${product.title}">
          <div class="dds-chat-product-title-area">
            <h4 class="dds-chat-product-title">${product.title}</h4>
            <p class="dds-chat-product-benefit">✓ ${benefit}</p>
          </div>
        </div>
        <div class="dds-chat-product-actions" style="flex-direction: column; align-items: stretch; gap: 8px;">
          ${variantsHtml}
          <button class="dds-chat-add-btn" style="width: 100%; height: 48px; font-size: 16px; font-weight: 700;"
            data-vid="${defaultVid}"
            data-qty="${defaultQty}"
            data-title="${product.title}"
            onclick="ddsAddToCart(event, this.getAttribute('data-vid'), this.getAttribute('data-title'), parseInt(this.getAttribute('data-qty')||'1'))">
            Adaugă în coș
          </button>
        </div>
        <a href="${product.url}" class="dds-chat-promo-banner" target="_blank">
          <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg> 
          Vezi detalii produs
        </a>
      `;

      // FIX CRITIC: folosim messagesContainer (nu 'container' care era nedefinit)
      const typingWrapper = document.getElementById('ddsTypingWrapper');
      messagesContainer.insertBefore(card, typingWrapper);
    } catch(e) {
      console.error('Failed to fetch product card', e);
    }
  }

  window.openCartFromChat = function(e) {
    if(e) e.preventDefault();
    closeChatbot();
    
    // Attempt clicking Dawn's cart icon bubble
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
       cartIcon.click();
    } else {
       window.location.href = '/cart';
    }
  };

  // Safety net: cand cart-drawer-ul se inchide, Contact FAB este garantat restaurat daca Elena este inchisa
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    const cartObserver = new MutationObserver(() => {
      if (!cartDrawerEl.classList.contains('active') && !chatWindow.classList.contains('active')) {
        const fab = document.getElementById('ddsContactFabContainer');
        if (fab) fab.classList.remove('chatbot-hidden');
      }
    });
    cartObserver.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Global func for Add to cart — trimite Varianta 1 cu cantitate reala (Mix&Match)
  window.ddsAddToCart = async function(e, variantId, productTitle, quantity) {
    e.preventDefault();
    e.stopPropagation();
    const btn = e.currentTarget;
    if (btn.disabled) return;
    const originalContent = btn.innerHTML;
    btn.innerHTML = 'Se adaugă...';
    btn.disabled = true;
    const qty = quantity && quantity > 0 ? quantity : 1;

    const formData = new FormData();
    formData.append('id', variantId);   // mereu Varianta 1
    formData.append('quantity', qty);   // cantitate reala (1/3/6)

    try {
      const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      
      // Cerem sectiunile esentiale pentru update vizual fara refresh
      formData.append('sections', 'cart-icon-bubble,cart-drawer');
      formData.append('sections_url', window.location.pathname);

      const resp = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!resp.ok) {
        const errText = await resp.text();
        console.error('[DDS Chatbot] cart/add.js error:', resp.status, errText);
        throw new Error(errText);
      }

      const parsedState = await resp.json();

      btn.innerHTML = '✔ Adăugat';
      btn.style.background = '#4ade80';
      btn.disabled = false;
      
      // Functie helper pt extragerea continutului sectiunilor
      function getInnerHTML(html, selector) {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const el = doc.querySelector(selector);
        return el ? el.innerHTML : doc.body.innerHTML;
      }
      
      // Updatam bucla cart-ului (numarul de produse) la TOATE elementele posibile
      if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        const bubbles = document.querySelectorAll('[id="cart-icon-bubble"]');
        bubbles.forEach(bubble => {
          bubble.innerHTML = getInnerHTML(parsedState.sections['cart-icon-bubble'], '#shopify-section-cart-icon-bubble') || getInnerHTML(parsedState.sections['cart-icon-bubble'], '.shopify-section') || parsedState.sections['cart-icon-bubble'];
        });
      }
      
      // Updatam drawer-ul cu HTML complet din raspunsul Shopify
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && parsedState.sections && parsedState.sections['cart-drawer']) {
        const newDoc = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
        const isCurrentlyEmpty = cartDrawer.classList.contains('is-empty');

        if (isCurrentlyEmpty) {
          // Cosul trece de la gol la primul produs:
          // Inlocuim inner HTML-ul din #CartDrawer si scoatem clasa is-empty
          const newCartDrawerDiv = newDoc.getElementById('CartDrawer');
          const existingCartDrawerDiv = document.getElementById('CartDrawer');
          if (newCartDrawerDiv && existingCartDrawerDiv) {
            existingCartDrawerDiv.innerHTML = newCartDrawerDiv.innerHTML;
          }
          cartDrawer.classList.remove('is-empty');
        } else if (cartDrawer.renderContents) {
          // Cos deja populat — update normal via Dawn renderContents
          const originalOpen = cartDrawer.open;
          cartDrawer.open = function() {};
          cartDrawer.renderContents(parsedState);
          setTimeout(() => { cartDrawer.open = originalOpen; }, 150);
        }
      }
      
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      
      // Generate AI message confirmation
      addMessage(`✅ Am adăugat **${productTitle}** în coșul tău.<br><br> <a href="#" onclick="openCartFromChat(event)" style="font-weight: 700; color: #d97706; text-decoration: underline;">👉 Deschide coșul acum</a> pentru a finaliza comanda.`, 'assistant');

    } catch (err) {
      console.error('[DDS Chatbot] Add to cart failed:', err);
      btn.innerHTML = '⚠ Eroare';
      btn.style.background = '#ef4444';
      btn.disabled = false;
      setTimeout(() => {
        btn.innerHTML = originalContent;
        btn.style.background = '';
      }, 3000);
    }
  };

  // Quick reply logic
  window.sendQuickReply = function(text) {
    hideFaqPermanently(); // Ascunde FAQ dupa prima interactiune
    chatInput.value = text;
    handleSend();
  };

  function scrollToBottom() {
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  // Sare la inceputul unui element din container (fara jitter si re-ancoreaza dupa imagini)
  function scrollToMessageStart(el) {
    if (!el || !messagesContainer) return;
    const performScroll = () => {
      const containerRect = messagesContainer.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      const targetScroll = messagesContainer.scrollTop + (elRect.top - containerRect.top) - 10;
      messagesContainer.scrollTo({
        top: Math.max(0, targetScroll),
        behavior: 'smooth'
      });
    };
    requestAnimationFrame(performScroll);
    setTimeout(performScroll, 100);
    setTimeout(performScroll, 300);
  }

  async function handleSend() {
    if (isGenerating) return;
    
    const text = chatInput.value.trim();
    if (!text) return;

    hideFaqPermanently(); // Ascunde FAQ la primul mesaj scris manual
    isGenerating = true;

    interactionCount++;
    if (interactionCount > 15) {
      chatInput.disabled = true;
      chatInput.placeholder = "Ai atins limita de mesaje.";
      sendBtn.disabled = true;
      addMessage("Ai atins limita de mesaje pentru această sesiune. Pentru a discuta direct cu un operator, te rugăm să ne suni apăsând pe numărul de mai jos:\n\n 0771 104 521", 'assistant');
      isGenerating = false;
      return;
    }

    // Detectia operator/uman e acum gestionata de AI via function calling
    // Nu mai blocam mesajul — il trimitem la worker si AI-ul decide

    // Add user message
    addMessage(text, 'user');
    chatInput.value = '';
    messageHistory.push({ role: 'user', content: text });

    // Show typing
    const typingWrap = document.getElementById('ddsTypingWrapper');
    typingWrap.style.display = 'flex';
    scrollToBottom();

    try {
      // Fetch current cart for context awareness
      let cartItems = [];
      try {
        const cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (cartResp.ok) {
          const cartData = await cartResp.json();
          cartItems = (cartData.items || []).map(item => item.handle);
        }
      } catch (cartErr) {
        // Silent fail — cart context is optional
      }

      const response = await fetch(CF_WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: messageHistory,
          live_stock: window.DDS_LIVE_STOCK || '',
          cart_items: cartItems
        })
      });

      const data = await response.json();
      typingWrap.style.display = 'none';

      if (data.reply) {
        const assistantWrapper = addMessage(data.reply, 'assistant');
        messageHistory.push({ role: 'assistant', content: data.reply });

        // Rendăm produsele recomandate din structura Function Calling
        if (data.recommended_products && data.recommended_products.length > 0) {
          await Promise.all(data.recommended_products.map(rp => fetchProductCard(rp.handle, rp.beneficiu)));
        }

        // Derulăm ferm la începutul mesajului Elenei după ce toate cardurile au fost adăugate în DOM
        scrollToMessageStart(assistantWrapper);

        // Arată cardul callback dacă AI-ul a detectat nevoie de operator
        if (data.needs_human) {
          showCallbackCard(data.alert_type);
        }
      } else {
        addMessage("A apărut o eroare la conexiune. Te rugăm să încerci din nou.", 'assistant');
      }

    } catch (e) {
      console.error(e);
      typingWrap.style.display = 'none';
      addMessage("Nu am putut contacta asistentul. Revino puțin mai târziu.", 'assistant');
    } finally {
      isGenerating = false;
    }
  }

  // --- Callback Card Logic ---
  function showCallbackCard(alertType) {
    const card = document.getElementById('ddsCallbackCard');
    if (!card) return;
    card.style.display = 'block';
    // Scroll la card
    setTimeout(() => card.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
  }

  sendBtn.addEventListener('click', handleSend);
  chatInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') handleSend();
  });
});
